import React, { useCallback, useMemo } from 'react'
import useCruiseSearchFacets from 'hooks/Cruise/useCruiseSearchFacets'
import SearchLocationInput from 'components/Search/SearchForm/SearchLocationInput/SearchLocationInput'

function CruiseDepartureInputFilter({ onChange }: { onChange: (values: App.CruiseGlobalFilters) => void}) {
  const [facets] = useCruiseSearchFacets({ facetTypes: ['departure_ports'] })

  const getSearchItem = useCallback((item?: App.SearchItem | undefined) => {
    onChange({ searchItem: item })
  }, [onChange])

  const departures = useMemo((): Array<App.SearchItem> => {
    return facets
      .filter((facet) => facet.category === 'departure_ports')
      .map((facet) => ({
        searchType: 'destination',
        value: facet.value,
        format: {
          mainText: facet.name,
        },
      }))
  }, [facets])

  return <SearchLocationInput
    label="Departure port"
    placeholder="All departure ports"
    onChange={getSearchItem}
    isSecondaryLocation
    placeholderItems={departures}
    overrideSearchItems={departures}
    variant="dropdown"
  />
}

export default CruiseDepartureInputFilter
